import React, { useState } from 'react';


const AccordionItem = ({ title, content, isOpen, onClick }) => (
    <div className="accordion-item">
        <div
            className={`accordion-header ${isOpen ? 'active' : ''}`}
            onClick={onClick}
        >
            {title}
        </div>
        <div className={`accordion-body ${isOpen ? 'open' : ''}`}>
            {content}
        </div>
    </div>
);



export default function Accordion({ items }) {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleItem = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="accordion">
            {items.map((item, index) => (
                <AccordionItem
                    key={index}
                    title={item.title}
                    content={item.content}
                    isOpen={openIndex === index}
                    onClick={() => toggleItem(index)}
                />
            ))}
        </div>
    );
}
